export const PREWAGER_CANCELATION_IN_PROGRESS = -5;
